import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getWorksProductivityNorms(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_PRODUCTIVITY_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].GET_WORKS_PRODUCTIVITY_NORMS,
		options
	)
}

function _getWorksProductivityNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_PRODUCTIVITY_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].GET_WORKS_PRODUCTIVITY_NORM,
		options
	)
}

function _createWorksProductivityNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_PRODUCTIVITY_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].CREATE_WORKS_PRODUCTIVITY_NORM,
		options
	)
}

function _putWorksProductivityNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_PRODUCTIVITY_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].PUT_WORKS_PRODUCTIVITY_NORM,
		options
	)
}

function _patchWorksProductivityNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_PRODUCTIVITY_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].PATCH_WORKS_PRODUCTIVITY_NORM,
		options
	)
}

function _deleteWorksProductivityNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_PRODUCTIVITY_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].DELETE_WORKS_PRODUCTIVITY_NORM,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].GET_WORKS_PRODUCTIVITY_NORMS]: _getWorksProductivityNorms,

	[ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].GET_WORKS_PRODUCTIVITY_NORM]: _getWorksProductivityNorm,

	[ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].CREATE_WORKS_PRODUCTIVITY_NORM]: _createWorksProductivityNorm,

	[ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].PUT_WORKS_PRODUCTIVITY_NORM]: _putWorksProductivityNorm,

	[ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].PATCH_WORKS_PRODUCTIVITY_NORM]: _patchWorksProductivityNorm,

	[ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].DELETE_WORKS_PRODUCTIVITY_NORM]: _deleteWorksProductivityNorm,
}
